import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import SectionHero from '../../Helpers/SectionHero';
import SectionCTA from '../../Helpers/SectionCTA';
import ServiceCard from '../../Helpers/ServiceCard';
import redesDatacenter from '../../../assets/images/services/redes_datacenter.jpg';
import { useLanguage } from '../../../i18n/LanguageContext';

const blockIcons = ['fa-network-wired', 'fa-ethernet', 'fa-server'];

const Redes = () => {
  const { t } = useLanguage();
  const blocks = t('redes.blocks').map((b, i) => ({ ...b, icon: blockIcons[i] }));

  return (
    <>
      {/* Hero */}
      <SectionHero badge={t('nav.tecnologia')} title={t('redes.title')} image={redesDatacenter} imagePos="center">
        <p className="text-blue-100 text-lg md:text-xl">
          {t('redes.subtitle')}
        </p>
      </SectionHero>

      {/* Bloques de servicios — fondo claro, lenguaje visual alineado al inicio */}
      <section
        className="relative overflow-hidden py-24"
        style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%)' }}
      >
        <div
          className="dot-grid pointer-events-none absolute top-10 right-8 w-44 h-32 opacity-60 hidden md:block"
          style={{ maskImage: 'linear-gradient(225deg, #000, transparent 75%)', WebkitMaskImage: 'linear-gradient(225deg, #000, transparent 75%)' }}
        ></div>
        <div className="contain relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">
            {blocks.map((block, index) => (
              <ServiceCard
                key={index}
                index={index}
                icon={block.icon}
                subtitle={block.subtitle}
                title={block.title}
                items={block.items}
                delay={index * 100}
                titleClass="text-2xl"
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <SectionCTA
        title={t('redes.ctaTitle')}
        text={t('redes.ctaText')}
      />
    </>
  );
};

export default Redes;
